import ReactDOM from 'react-dom';
import App from './components/App';
import './style/style.css';

ReactDOM.render(<App />, document.getElementById('root'));
